"use client";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

function getValueTrendClass(normalizedTrend) {
  if (normalizedTrend === "increased") return "kbv-odds-value--up";
  if (normalizedTrend === "decreased") return "kbv-odds-value--down";
  return "";
}

export default function OddsMatch1x2Cell({ value, trend = "unchanged" }) {
  const display = value != null && value !== "" ? value : "-";
  const normalizedTrend = normalizeTrend(trend);
  const trendClass = getValueTrendClass(normalizedTrend);
  const hasArrow = normalizedTrend === "increased" || normalizedTrend === "decreased";
  const normalCellClass = !hasArrow ? "kbv-odds-cell--normal" : "";

  return (
    <div className={`kbv-1x2-cell flex items-center justify-center p-0 h-5 leading-5 text-xs cursor-pointer relative w-full rounded-sm ${normalCellClass} ${trendClass}`}>
      <span
        className={`inline-flex items-center justify-center relative font-bold text-xs whitespace-nowrap rounded-[3px] transition-colors text-[color:var(--kbv-odds-value-color)] ${trendClass}`}
      >
        <strong>{display}</strong>
      </span>
    </div>
  );
}
